import { useEffect } from "react";
import LandscapeProgramLayout from "./Programs/LandscapeProgramLayout";
import useCountDown from "../hooks/useCountDown";
import BottomNav from "./Programs/BottomNav";
import { useAuthContext } from "../context/auth";
import GredientCircularProgress from "./GredientCircularProgress";

function Rest({ time = 60, nowStep }: { time?: number; nowStep: number }) {
  const { sendSetStep, step, emitter } = useAuthContext();
  const { count, start, stop } = useCountDown(
    time,
    () => {
      console.log("[Rest] Timer finished, moving to next step");
      sendSetStep(step + 1);
    },
    true,
    false // Don't reset to initialValue when complete, stay at 0
  );

  useEffect(() => {
    // 마운트되면 바로 시작
    console.log("[Rest] Starting countdown immediately");
    start();

    const emitterRef = emitter.current;

    const handleResume = () => {
      console.log("[Rest] Resume event received");
      start(undefined, true);
    };

    const handlePause = () => {
      console.log("[Rest] Pause event received");
      stop();
    };

    emitterRef.on("resume", handleResume);
    emitterRef.on("pause", handlePause);

    return () => {
      emitterRef.off("resume", handleResume);
      emitterRef.off("pause", handlePause);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LandscapeProgramLayout step={nowStep}>
      <div className="bg-bg w-full flex-1 flex justify-center">
        <div className="flex flex-col items-center mt-[124px] gap-3">
          <h1 className="text-[100px] font-bold gradient-text">READY</h1>
          <div className="w-[432px] h-[432px]">
            <GredientCircularProgress maxValue={time} value={count} />
          </div>
        </div>
      </div>
      <BottomNav />
    </LandscapeProgramLayout>
  );
}

export default Rest;
